import { PopulationQualifierKind } from "@redotech/redo-billing-common/checkout-optimization-qualifier";
import * as z from "zod";

/**
 * Attest that a leaf population on the ACTIVE tree earns a qualifier.
 * Trusted users only; the schema alone keeps order-scoped kinds out.
 */
export const writeCheckoutAttestation = {
  name: "writeCheckoutAttestation" as const,
  input: z.object({
    checkoutTreeNodeId: z.string(),
    kind: z.nativeEnum(PopulationQualifierKind),
    note: z.string().min(1),
  }),
  output: z.null(),
};
